import {
    Component, ComponentFactoryResolver, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {PanelItem} from './panel-item';
import {PanelDirective} from './panel.directive';
import {PanelComponent} from './panel.component';
import {PANEL_ITEM} from './abc.options';

@Component({
    selector: 'zj-carousel',
    template: `
        <div class="carousel slide">
            <ol class="carousel-indicators" *ngIf="(panels.length !== 1) && zjDots">
                <li [ngClass]="{'active':i===currentPanelIndex}" (click)="active(i)"
                    *ngFor="let c of panels;index as i;trackBy: trackByFn;"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item" [ngClass]="lightSpeedIn">
                    <ng-template panel-host></ng-template>
                </div>
            </div>
            <a class="carousel-control-prev" (click)="prev()" *ngIf="panels.length>0 && zjArrows">
                <span class="anticon anticon-left"></span>
            </a>
            <a class="carousel-control-next" (click)="next()" *ngIf="panels.length>0 && zjArrows">
                <span class="anticon anticon-right"></span>
            </a>
        </div>
    `,
    styles: [`.carousel{position:relative;height:100%}.carousel .carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;list-style:none;margin:0 15% .8rem}.carousel .carousel-indicators .active{background-color:#fff}.carousel .carousel-indicators li{position:relative;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:rgba(255,255,255,.5)}.carousel .carousel-indicators li:hover{cursor:pointer}.carousel .carousel-inner{height:100%;position:relative;width:100%;overflow:hidden}.carousel .carousel-inner .carousel-item{position:relative;height:100%;background-color:rgba(85,70,172,.19);padding-bottom:20px;align-items:center;width:100%;transition:-webkit-transform .6s ease;transition:-webkit-transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel .carousel-control-next,.carousel .carousel-control-prev{position:absolute;top:0;bottom:0;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel .carousel-control-next .anticon,.carousel .carousel-control-prev .anticon{display:inline-block;width:20px;height:20px;background:center center/100% 100% no-repeat;font-size:24px;font-weight:bolder}.carousel .carousel-control-prev{left:0}.carousel .carousel-control-next{right:0}.carousel a{text-decoration:none;background-color:transparent}.carousel a:hover{color:#fff;outline:0;opacity:.9}@-webkit-keyframes lightSpeedRightIn{from{-webkit-transform:translate3d(50%,0,0);transform:translate3d(50%,0,0);opacity:0}60%,80%{opacity:1}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}@keyframes lightSpeedRightIn{from{-webkit-transform:translate3d(50%,0,0);transform:translate3d(50%,0,0);opacity:0}60%,80%{opacity:1}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}.lightSpeedRightIn{-webkit-animation-name:lightSpeedRightIn;animation-name:lightSpeedRightIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}@-webkit-keyframes lightSpeedLeftIn{from{-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0);opacity:0}60%,80%{opacity:1}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}@keyframes lightSpeedLeftIn{from{-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0);opacity:0}60%,80%{opacity:1}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}.lightSpeedLeftIn{-webkit-animation-name:lightSpeedLeftIn;animation-name:lightSpeedLeftIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}`]
})
export class CarouselComponent implements OnInit, OnChanges {

    currentPanelIndex = 0;
    @Input() zjArrows = true;
    @Input() zjDots = true;
    @Input() zjAutoPlay = false;

    @Input() panels: PanelItem[] = [];
    @ViewChild(PanelDirective) panelHost: PanelDirective;

    @Output() onActive = new EventEmitter();

    lightSpeedIn;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                @Inject(PANEL_ITEM) @Optional() panels: PanelItem[]) {
        if (panels) {
            this.panels = panels;
        }
    }

    loadComponent() {
        console.log('loading component');
        this.currentPanelIndex = this.currentPanelIndex % this.panels.length;
        const panelItem = this.panels[this.currentPanelIndex];

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(panelItem.component);

        const viewContainerRef = this.panelHost.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<PanelComponent>componentRef.instance).data = panelItem.data;

        this.onActive.emit(panelItem.data);
    }


    ngOnInit(): void {

        if (!this.panels || this.panels.length === 0) {
            return;
        }
        this.loadComponent();

        if (this.zjAutoPlay) {
            // todo(ccliu): è½®æ­åå®¹
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('-----------');
        if (!this.panels || this.panels.length === 0) {
            return;
        }
        this.loadComponent();

        if (this.zjAutoPlay) {
            // todo(ccliu): è½®æ­åå®¹
        }
    }

    active(i: number) {
        if (this.currentPanelIndex === i) {
            return;
        }
        if (this.currentPanelIndex > i) {
            this.lightSpeedIn = 'lightSpeedLeftIn';
        } else {
            this.lightSpeedIn = 'lightSpeedRightIn';
        }
        this.currentPanelIndex = i;
        this.loadComponent();
    }

    next() {
        ++this.currentPanelIndex;
        this.loadComponent();
        this.lightSpeedIn = 'lightSpeedRightIn';
        this.clearAnimationClass();
    }

    prev() {
        this.currentPanelIndex = this.currentPanelIndex > 0 ? this.currentPanelIndex - 1 : this.panels.length - 1;
        this.loadComponent();
        this.lightSpeedIn = 'lightSpeedLeftIn';
        this.clearAnimationClass();
    }

    clearAnimationClass() {
        setTimeout(() => {
            this.lightSpeedIn = null;
        }, 1000);
    }

    trackByFn(index) {
        return index;
    }

}
